import { motion } from "framer-motion";
import { GoldButton } from "./GoldButton";
import { PhoneMockup } from "./PhoneMockup";
import { Reveal, MaskedLine } from "./Reveal";

const STEPS = [
  { n: "01", title: "Entra", text: "Ogni mattina ricevi una nuova direzione." },
  { n: "02", title: "Allinea", text: "Parola, preghiera e riflessione per riportare Dio al centro." },
  { n: "03", title: "Disciplina", text: "Azioni concrete per lavorare su mente, identità, abitudini e responsabilità." },
  { n: "04", title: "Muovi", text: "Allenamento, movimento e indicazioni semplici per tornare a prenderti cura del corpo." },
  { n: "05", title: "Attraversa", text: "Continua un giorno alla volta per 40 giorni." },
];

export const FortyDays = () => (
  <section className="relative bg-charcoal px-5 py-28 sm:px-8 lg:py-40" data-testid="forty-days-section">
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <p className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">
          <span className="h-px w-10 bg-gold/60" /> Cosa succede nei 40 giorni
        </p>
      </Reveal>
      <div className="mt-6 grid gap-10 lg:grid-cols-2 lg:items-end">
        <h2 className="font-display text-4xl font-bold uppercase leading-[1.05] tracking-tight text-ivory sm:text-5xl lg:text-6xl">
          <MaskedLine delay={0.1}>Non devi inventarti</MaskedLine>
          <MaskedLine delay={0.22}>
            <span className="text-gold">il percorso.</span>
          </MaskedLine>
        </h2>
        <Reveal delay={0.3}>
          <p className="max-w-md text-base leading-relaxed text-ivory/60 sm:text-lg lg:ml-auto">
            Ogni giorno troverai un nuovo passo da compiere. Tutto dentro l'app — niente PDF, niente gruppi WhatsApp.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-16 lg:grid-cols-[1fr_340px] lg:gap-20">
        <div className="border-t border-ivory/10">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: 0.05 * i, ease: [0.16, 1, 0.3, 1] }}
              className="group grid gap-4 border-b border-ivory/10 py-10 transition-colors duration-500 hover:bg-ivory/[0.02] sm:grid-cols-[100px_1fr] sm:gap-8"
              data-testid={`step-card-${s.n}`}
            >
              <span className="font-display text-5xl font-bold text-ivory/15 transition-colors duration-500 group-hover:text-gold sm:text-6xl">
                {s.n}
              </span>
              <div>
                <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-ivory sm:text-3xl">{s.title}</h3>
                <p className="mt-3 max-w-lg text-base leading-relaxed text-ivory/60">{s.text}</p>
              </div>
            </motion.div>
          ))}
          <Reveal delay={0.2} className="pt-12">
            <GoldButton testId="forty-days-cta-button" />
          </Reveal>
        </div>

        <div className="relative hidden lg:block">
          <div className="sticky top-28 space-y-10">
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            >
              <PhoneMockup screen="journey" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
              className="ml-16"
            >
              <PhoneMockup screen="workout" />
            </motion.div>
          </div>
        </div>
      </div>

      <div className="mt-16 grid grid-cols-2 gap-8 lg:hidden">
        <PhoneMockup screen="journey" glow={false} />
        <PhoneMockup screen="workout" glow={false} className="mt-12" />
      </div>
    </div>
  </section>
);
